import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useMatches } from 'react-router-dom'
import { useBranding } from '~/helpers/branding/branding-context'
import { useAuth } from '~/helpers/store/auth'
import { pageTitle, screenTitleForRole, screenTitleKey } from '~/routes/route-handle'

/**
 * Titre de la page et annonce de navigation (RGAA 8.6, 12.8).
 *
 * Dans une application monopage, changer d'écran ne recharge rien : sans titre
 * propre à l'écran, tous les onglets s'appelaient pareil, et un lecteur d'écran
 * n'apprenait pas qu'il avait changé de page. Le titre vient de la route
 * (`handle.title`) ; il est annoncé poliment après chaque navigation, pas au
 * premier affichage.
 */
function RouteAnnouncer() {
  const { t } = useTranslation()
  const { appName } = useBranding()
  const { pathname } = useLocation()
  const role = useAuth(state => state.payload?.role)
  const key = screenTitleForRole(screenTitleKey(useMatches()), role)
  const screen = key ? t(key) : undefined
  // Annonce à chaque changement d'ÉCRAN, pas de paramètre : nettoyer `?tour=…`
  // de l'adresse ne doit rien dire. Rien au premier affichage.
  const [lastPath, setLastPath] = useState(pathname)
  const [announcement, setAnnouncement] = useState('')
  if (pathname !== lastPath) {
    setLastPath(pathname)
    setAnnouncement(t('pageTitle.announce', { title: screen ?? appName }))
  }

  useEffect(() => {
    document.title = pageTitle(screen, appName)
  }, [screen, appName])

  return <p className="sr-only" aria-live="polite" aria-atomic="true">{announcement}</p>
}

export default RouteAnnouncer
